<template>
    <BreadCrumb PageTitle="Affecter des files aux agents de controle" />
    <Affectation />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import Affectation from "@/components/Affectation/Affectation.vue";


export default defineComponent({
    name: "AffectationPage",
    components: {
        BreadCrumb,
        Affectation,
    },
});
</script>